<template>
	<div class="container">

	</div>
</template>

<script>
export default {
	name: "TestError",
  	mounted() {
      throw new Error("I am a an error");
	}
};
</script>
<style scoped>

</style>